import request from "@/utils/request";

let Bargain = {
    /*活动列表*/
    activeList(data, errorback) {
        return request._post("/merch/activity.bargain/index", data, errorback);
    },
    getGoods(data, errorback) {
        return request._get("/merch/activity.bargain/add", data, errorback);
    },
    addGoods(data, errorback) {
        return request._post("/merch/activity.bargain/add", data, errorback);
    },
    /*我的活动列表*/
    myList(data, errorback) {
        return request._post("/merch/activity.bargain/my", data, errorback);
    },
    /*根据主键查询*/
    detailGoods(data, errorback) {
        return request._get("/merch/activity.bargain/edit", data, errorback);
    },
    /*保存*/
    saveGoods(data, errorback) {
        return request._post("/merch/activity.bargain/edit", data, errorback);
    },
    delGoods(data, errorback) {
        return request._post("/merch/activity.bargain/del", data, errorback);
    }
};

export default Bargain;



// WEBPACK FOOTER //
// ./src/api/bargain.js